export function trimEmptyString<T extends object>(obj: T): Partial<T> {
  const updatedItems = Object.entries(obj).map(([key, value]) => {
    const updatedValue = value !== '' ? value : undefined
    return [key, updatedValue]
  })
  return Object.fromEntries(updatedItems)
}
